import { bootstrapApplication } from '@angular/platform-browser';

import { clearChunkReloadGuard } from '@core/utils/chunk-load-error.util';

import { appConfig } from './app/app.config';
import { App } from './app/app';

clearChunkReloadGuard();

bootstrapApplication(App, appConfig).catch((err) => console.error(err));
